import { notifyError, notifySuccess } from "../../helpers/helpers";
import { auction } from "../config/urlConfig";
import { singleCompletedAuctionDetails } from "./singleAuction";
import { saveAs } from "file-saver";
import { toast } from "react-toastify";


export const postAuctionReportWithRejectedBySeller =
    (
        id,
        acceptedOffers,
        rejectedOffers,
        rejectedMessage,
        setIsModelOpen,
        setAcceptedOffers,
        setRejectedOffers,
    ) =>
        async (dispatch) => {
            dispatch({ type: "AUCTION_REPORT_LOADING" });
            try {
                const { data } = await auction.put(`auction/update/reject-auction-report/${id}`, { acceptedOffers, rejectedOffers, rejectedMessage });
                dispatch({ type: "AUCTION_REPORT_SUCCESS", payload: data });
                dispatch(singleCompletedAuctionDetails(id));
                notifySuccess("Auction report submitted successfully");
                setAcceptedOffers([]);
                setRejectedOffers([]);
                setIsModelOpen(false);
            } catch (error) {
                setIsModelOpen(false);
                dispatch({ type: "AUCTION_REPORT_FAILED" });
                notifyError(
                    error.response ? error.response?.data : error.message,
                    error.response?.status
                );
            }
        };

export const postAuctionReportWithAcceptedBySeller =
    (
        id,
        acceptedOffers,
        setIsModelOpen,
        setAcceptedOffers,
        setRejectedOffers,
    ) =>
        async (dispatch) => {
            dispatch({ type: "AUCTION_REPORT_LOADING" });
            try {
                const { data } = await auction.put(`/auction/update/accept-auction-report/${id}`, { acceptedOffers });
                dispatch({ type: "AUCTION_REPORT_SUCCESS", payload: data });
                dispatch(singleCompletedAuctionDetails(id));
                notifySuccess("Auction report submitted successfully");
                setAcceptedOffers([]);
                setRejectedOffers([]);
                setIsModelOpen(false);
            } catch (error) {
                setIsModelOpen(false);
                dispatch({ type: "AUCTION_REPORT_FAILED" });
                notifyError(
                    error.response ? error.response?.data : error.message,
                    error.response?.status
                );
            }
        };


export const getAuctionReportPdf = (id) => async (dispatch) => {
    dispatch({ type: "GET_AUCTION_REPORT_LOADING" });
    try {
        const response = await auction.get(`/auction/read/auction-reports?auctionId=${id}`, {
            responseType: "blob",
        });
        const pdfBlob = new Blob([response.data], { type: "application/pdf" });
        const pdfUrl = URL.createObjectURL(pdfBlob);
        dispatch({ type: "GET_AUCTION_REPORT_SUCCESS", payload: pdfUrl });
    } catch (error) {
        notifyError(
            error.response ? error.response?.data : error.message,
            error.response?.status
        );
        dispatch({ type: "GET_AUCTION_REPORT_FAILED" });
    }
};

export const downloadAuctionReportPdf = (id) => async (dispatch) => {
    const toastID = toast.loading("please wait..");
    dispatch({ type: "SHOW_LOADING_DOWNLOAD" });
    try {
        const response = await auction.get(`/auction/read/auction-reports?auctionId=${id}`, {
            responseType: "blob",
        });
        const pdfBlob = new Blob([response.data], { type: "application/pdf" });
        saveAs(pdfBlob, "Auction-Report");
        dispatch({ type: "GET_DOWNLOAD_REPORT_DATA" });
        toast.update(toastID, {
            render: "File downloaded successfully",
            isLoading: false,
            autoClose: 5000,
            type: "success",
        });
    } catch (error) {
        toast.update(toastID, {
            render: "Failed to download",
            isLoading: false,
            autoClose: 5000,
            type: "error",
        });
        notifyError(error.response ? error.response?.data : error.message, error.response?.status);
        dispatch({ type: "HIDE_LOADING_REPORT_DOWNLOAD" });
    }
};